import { NgModule } from '@angular/core';
import { LogoComponent } from './logo/logo.component';

@NgModule({
  imports: [
  ],
  declarations: [LogoComponent],
  exports: [LogoComponent]
})
export class CelinaUiModule { }
